<template>
    <div class="mandate-item">
        <div class="mandate-item__left">
            <div class="mandate-item__header">
                <div class="mandate-item__number typographies-paragraph-medium-regular">
                    {{ mandate.number }}
                </div>
                <CompassTag v-if="mandate.status === 'revoked'" color="yellow" size="small">
                    {{ $t.__('common.labels.revoked') }}
                </CompassTag>
            </div>
            <div class="mandate-item__types">
                <CompassTag v-for="type in mandate.types" :key="type" color="stroked">
                    {{ $t.__(`settings.mandate.type.${type}`) }}
                </CompassTag>
            </div>
        </div>
        <div class="mandate-item__right">
            <div class="mandate-item__actions">
                <template v-if="mandate.status === 'pending'">
                    <CompassButton
                        :label="$t.__('settings.mandate.button.cancel')"
                        type="tertiary-destructive"
                        @click="cancelMandate"
                    />
                    <CompassButton
                        :label="$t.__('settings.mandate.button.send_again')"
                        leftIcon="bell"
                        type="secondary"
                        :loading="isSendingEmail"
                        @click="resendSignatureEmail"
                    />
                </template>
                <CompassButton
                    v-else-if="mandate.status === 'ok' && mandate.pdf_link"
                    :label="$t.__('settings.mandate.button.download')"
                    leftIcon="download"
                    @click="downloadMandate"
                />
            </div>
            <div class="mandate-item__legal-rep">
                <p v-if="mandate.status === 'pending'" class="typographies-paragraph-small-regular">
                    <strong class="typographies-paragraph-small-black">
                        {{ $t.__('settings.mandate.pending') }}
                    </strong>
                    {{
                        $t.__('settings.mandate.sent_to', {
                            email: mandate.legal_representative_email,
                        })
                    }}
                </p>
                <p v-else-if="mandate.status === 'ok'" class="typographies-paragraph-small-black">
                    {{
                        $t.__('settings.mandate.signed_at', {
                            date: $filters.saasDateFormatted(mandate.signed_at),
                            name: getFullNameUser({
                                first_name: mandate.legal_representative_first_name,
                                last_name: mandate.legal_representative_last_name,
                            }),
                        })
                    }}
                </p>
            </div>
        </div>
        <MandateDeleteDialog
            v-if="showDeleteDialog"
            @mandateDeleted="$emit('mandateDeleted')"
            @close="showDeleteDialog = false"
        />
    </div>
</template>
<script>
import MandateDeleteDialog from 'vcomponents/settings/mandate/MandateDeleteDialog.vue';
import { resendMandateSignatureEmail } from 'api/mandate';
import { getFullNameUser } from 'Helpers/avatarHelper';

export default {
    components: {
        MandateDeleteDialog,
    },
    props: {
        mandate: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showDeleteDialog: false,
            isSendingEmail: false,
        };
    },
    methods: {
        getFullNameUser,
        cancelMandate() {
            this.showDeleteDialog = true;
        },
        resendSignatureEmail() {
            this.isSendingEmail = true;
            resendMandateSignatureEmail()
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$t.__('settings.MandateItem.send_email.success'),
                    });
                })
                .catch((error) => {
                    if (error.response.status === 409) {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$t.__('settings.MandateItem.send_email.too_many_requests'),
                        });
                    } else {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$t.__('settings.MandateItem.send_email.error'),
                        });
                    }
                })
                .finally(() => {
                    this.isSendingEmail = false;
                });
        },
        downloadMandate() {
            const link = document.createElement('a');
            link.href = this.mandate.pdf_link;
            link.download = `${this.$t.__('common.labels.mandate')}_${this.mandate.number}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>
<style lang="scss" scoped>
.mandate-item {
    background: var(--colors-common-background-subtle);
    border-radius: var(--spacing-1);
    display: flex;
    gap: var(--spacing-1);
    justify-content: space-between;
    padding: var(--spacing-2);

    &__left,
    &__right {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);
    }

    &__right {
        align-items: end;
    }

    &__header {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    &__number {
        word-break: break-word;
    }

    &__types {
        display: flex;
        gap: var(--spacing-1);
    }

    &__actions {
        display: flex;
        gap: var(--spacing-3);

        @media only screen and (max-width: 1100px) {
            align-items: end;
            flex-direction: column;
            gap: var(--spacing-1);
        }
    }

    &__legal-rep {
        color: var(--colors-common-text-subtle-default);
        margin: 0;
        text-align: right;

        p {
            margin: 0;
        }
    }
}
</style>
